// export const BASE_URL = "https://api.nextlead.ma"
// export const BASE_URL = "https://api.topselleraffiliate.ma"
export const BASE_URL = "https://api.simoexpress.com"
// export const BASE_URL = "http://127.0.0.1:8000"
// export const BASE_URL = "http://192.168.2.5:8000"

export const appConfig = {
  // name: "NextLead",
  // slug: "nextlead",

  name: "Simoexpress",
  slug: "simoexpress",

  // name: "TopSeller",
  // slug: "topseller",
}

export const getImageUrl = (imagePath) => {
  if (!imagePath) return null

  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
    return imagePath
  }

  return `${BASE_URL}/storage/${imagePath}`
}